import { render, staticRenderFns } from "./MemberAddr.vue?vue&type=template&id=4d88ff90&scoped=true&"
import script from "./MemberAddr.vue?vue&type=script&lang=js&"
export * from "./MemberAddr.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddr.vue?vue&type=style&index=0&id=4d88ff90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88ff90",
  null
  
)

export default component.exports